var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcLastMiddleLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 374,
    height: 374,
    viewBox: "0 0 374 374",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M222.419 335.552C171.846 386.124 89.8502 386.124 39.2773 335.551C-11.2956 284.978 -11.2949 202.984 39.2788 152.411L152.418 39.2761C202.991 -11.296 284.987 -11.2953 335.56 39.2776C386.133 89.8505 386.132 171.845 335.558 222.417L222.419 335.552Z",
    fill: "url(#paint0_linear_4550_71148)",
    stroke: "url(#paint1_linear_4550_71148)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4550_71148",
    x1: 77.4668,
    y1: 384.25,
    x2: 229.471,
    y2: -13.9589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55DCEA",
    stopOpacity: 0.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4550_71148",
    x1: 38.9238,
    y1: 335.904,
    x2: 258.577,
    y2: 116.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLastMiddleLeft);
export default __webpack_public_path__ + "static/media/ic-last-middle-left.ef352da0aa3ab8dd2e1cf0b64248251f.svg";
export { ForwardRef as ReactComponent };